import DataHandler from '../view/DataHandler';
import Grid from '../gui/Grid';
import Settings from './Settings';
import SideBar from '../sidebar/view/SideBar';
import View from '../gui/View';
import ElementCollection from '../shapes/ElementCollection';
import ToolCollection from '../tools/view/ToolCollection';
import ZoomMenu from '../gui/ZoomMenu';
import Menu from '../gui/Menu';
import MobileMenu from '../gui/MobileMenu';
import Spinner from '../gui/Spinner';
import Selection from '../shared/Selection';
import Cursor from '../gui/Cursor';
import PlantRow from '../sidebar/view/PlantRow';
import HoverSet from '../shared/HoverSet';
import SpeciesCollection from '../shared/SpeciesCollection';
import SpeciesInfo from '../sidebar/SpeciesInfo';
import ShapeFactory from '../shapes/ShapeFactory';
import DeviceDetector from "device-detector-js";

export default class ServiceProvider {
    listeners = {};

    constructor(p) {
        this.p = p;
    }

    init() {
        this.initValues();
        this.initInterface();
    }

    initValues() {
        this.mode = 'view';
        this.deviceDetector = new DeviceDetector();
        this.device = this.deviceDetector.parse(navigator.userAgent);
        this.mobile = this.device.device.type === 'smartphone';
        this.touch = ['tablet', 'smartphone'].includes(this.device.device.type);
        this.units = [];
        this.backgroundColor = this.p.color(240);
        this.enableHotKeys = true;
        this.spinner = new Spinner(this);
        this.selection = new Selection(this);
        this.hoverSet = new HoverSet(this);
        this.cursor = new Cursor(this);
        this.elementFactory = new ShapeFactory(this);
        this.mouseX = 0;
        this.mouseY = 0;
    }

    initInterface() {
        this.sideBar = new SideBar(this);
        this.sideBar.init();

        this.speciesInfo = new SpeciesInfo(this);

        this.zoomMenu = new ZoomMenu(this);
        this.zoomMenu.init();

        this.menu = this.mobile ? new MobileMenu(this) : new Menu(this);
        this.menu.init(
            [],
            ['settings', 'help', 'reset']
        );

        this.settings = new Settings(this);

        this.tools = new ToolCollection(this);
        this.tools.init();

        this.settings.init();

        this.grid = new Grid(this);
        this.view = new View(this);
        this.grid.recalculate();

        this.speciesCollection = new SpeciesCollection(this);
        this.elements = new ElementCollection(this);

        this.dataHandler = new DataHandler(this);
        this.dataHandler.getData();

        this.sideBar.activate();
    }

    newPlantRow(plant, container) {
        return new PlantRow(this, plant, container);
    }

    emit(event, data) {
        this.listeners[event]?.forEach(listener => listener(data));
    }

    on(event, listener) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(listener);
    }
}
